import React, { ReactElement } from 'react'
import { Text, IText } from '@mindfulchefuk/design-system/Text/Text'

export const ModalTitle = (
  textProps: IText & { children?: string }
): ReactElement => (
  <Text as="h2" {...textProps} variant="heading-sm" color="aubergine" />
)
